import { LegalPage } from '@/pages/LegalPage';
import { BUSINESS, LEGAL } from '@/data/business';

export default function PolitiqueConfidentialite() {
    return (
        <LegalPage
            title={<>Politique de<br />confidentialité</>}
            kicker="Protection des données · RGPD"
            updatedAt={LEGAL.lastUpdated}
            testId="legal-privacy-page"
        >
            <p>
                {LEGAL.companyName} accorde une grande importance à la protection de vos données
                personnelles. La présente politique explique quelles données sont collectées via le site
                {' '}<a href="https://www.manuvet.fr">www.manuvet.fr</a>, dans quel but, combien de temps
                elles sont conservées et quels sont vos droits, conformément au{' '}
                <strong>Règlement Général sur la Protection des Données (RGPD) — Règlement UE 2016/679</strong>
                {' '}et à la <strong>loi Informatique et Libertés</strong> du 6 janvier 1978 modifiée.
            </p>

            <h2>1 — Responsable de traitement</h2>
            <div className="info-block">
                <dl>
                    <dt>Responsable</dt>
                    <dd>{LEGAL.companyName} — {LEGAL.legalForm}</dd>
                    <dt>Adresse</dt>
                    <dd>{BUSINESS.address}, {BUSINESS.postalCode} {BUSINESS.city}</dd>
                    <dt>SIRET</dt>
                    <dd>{LEGAL.siret}</dd>
                    <dt>Contact données personnelles</dt>
                    <dd><a href={`mailto:${LEGAL.dataOfficerEmail}`}>{LEGAL.dataOfficerEmail}</a></dd>
                </dl>
            </div>

            <h2>2 — Données collectées et finalités</h2>
            <p>Nous collectons uniquement les données strictement nécessaires aux finalités suivantes :</p>

            <h3>a. Formulaire de contact</h3>
            <ul>
                <li><strong>Données collectées :</strong> nom, société (facultatif), téléphone, email, sujets d'intérêt, message.</li>
                <li><strong>Finalité :</strong> répondre à votre demande de devis, de renseignement ou de rendez-vous en boutique.</li>
                <li><strong>Base légale :</strong> exécution de mesures précontractuelles prises à votre demande (art. 6.1.b RGPD).</li>
                <li><strong>Durée de conservation :</strong> 3 ans à compter du dernier contact commercial, puis archivage limité pour obligations légales.</li>
                <li><strong>Destinataires :</strong> équipe interne {LEGAL.companyName} uniquement. Aucune revente, aucun transfert commercial.</li>
            </ul>

            <h3>b. Navigation & cookies techniques</h3>
            <ul>
                <li><strong>Données collectées :</strong> aucun cookie tiers publicitaire n'est déposé sur ce site. Seuls des cookies strictement techniques (session, préférences d'affichage) peuvent être utilisés.</li>
                <li><strong>Finalité :</strong> assurer le bon fonctionnement du site.</li>
                <li><strong>Base légale :</strong> intérêt légitime du responsable de traitement à assurer la sécurité et la stabilité du site.</li>
                <li><strong>Durée :</strong> le temps de la session ou 12 mois maximum.</li>
            </ul>

            <h3>c. Services tiers embarqués</h3>
            <p>Le site utilise les services suivants susceptibles de collecter des données de connexion (adresse IP) à des fins techniques :</p>
            <ul>
                <li><strong>Google Maps</strong> (Google LLC) — affichage de l'itinéraire vers la boutique. Politique : <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a></li>
                <li><strong>Google Places API</strong> — affichage des avis clients Google publics de la boutique.</li>
                <li><strong>Hostinger</strong> — hébergement technique (journaux serveurs). Politique : <a href="https://www.hostinger.fr/politique-confidentialite" target="_blank" rel="noopener noreferrer">hostinger.fr/politique-confidentialite</a></li>
            </ul>

            <h2>3 — Sécurité des données</h2>
            <p>
                {LEGAL.companyName} met en œuvre toutes les mesures techniques et organisationnelles
                appropriées pour préserver la confidentialité, l'intégrité et la disponibilité de vos
                données (connexion HTTPS chiffrée, accès restreint, sauvegardes régulières).
            </p>

            <h2>4 — Vos droits</h2>
            <p>Conformément au RGPD, vous disposez à tout moment des droits suivants :</p>
            <ul>
                <li><strong>Droit d'accès</strong> — obtenir la confirmation que des données vous concernant sont ou non traitées et en recevoir une copie.</li>
                <li><strong>Droit de rectification</strong> — corriger des données inexactes ou incomplètes.</li>
                <li><strong>Droit à l'effacement</strong> (« droit à l'oubli ») — obtenir la suppression de vos données dans les cas prévus par la loi.</li>
                <li><strong>Droit à la limitation</strong> du traitement.</li>
                <li><strong>Droit d'opposition</strong> au traitement pour motif légitime.</li>
                <li><strong>Droit à la portabilité</strong> des données que vous nous avez fournies.</li>
                <li><strong>Droit de définir des directives</strong> relatives au sort de vos données après votre décès.</li>
            </ul>
            <p>
                Pour exercer ces droits, contactez-nous par email à{' '}
                <a href={`mailto:${LEGAL.dataOfficerEmail}`}>{LEGAL.dataOfficerEmail}</a>{' '}
                ou par courrier à : {LEGAL.companyName} — {BUSINESS.address}, {BUSINESS.postalCode}
                {' '}{BUSINESS.city}. Une réponse vous sera apportée dans un délai maximal d'un mois.
            </p>

            <h2>5 — Réclamation auprès de la CNIL</h2>
            <p>
                Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne
                sont pas respectés, vous pouvez adresser une réclamation à la Commission Nationale de
                l'Informatique et des Libertés (CNIL) :
            </p>
            <div className="info-block">
                <dl>
                    <dt>CNIL — Commission Nationale Informatique et Libertés</dt>
                    <dd>3 Place de Fontenoy, TSA 80715, 75334 PARIS CEDEX 07</dd>
                    <dt>Site web</dt>
                    <dd><a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></dd>
                </dl>
            </div>

            <h2>6 — Modification de la politique</h2>
            <p>
                {LEGAL.companyName} se réserve le droit de modifier la présente politique de confidentialité
                à tout moment afin de l'adapter aux évolutions légales, réglementaires ou techniques. La
                version en vigueur est celle publiée sur cette page, datée au{' '}
                <strong>{LEGAL.lastUpdated}</strong>.
            </p>
        </LegalPage>
    );
}
